import { styled, spacing, Text, mq } from '@thg-commerce/enterprise-theme'
import { Grid, GridItem } from '@thg-commerce/gravity-system'
import { SafeHtml } from '@thg-commerce/gravity-elements'

export const Title = styled(SafeHtml)`
  ${(props) =>
    Text(
      props.theme.widget.referralStepGuide.title.entry,
      props.theme.widget.referralStepGuide.title.style,
    )}
  text-align: center;
  text-transform: ${(props) =>
    props.theme.widget.referralStepGuide.title.transform};
  text-decoration: ${(props) =>
    props.theme.widget.referralStepGuide.title.textDecoration};
  color: ${(props) => props.theme.widget.referralStepGuide.title.textColor};
  padding: 0 0 ${spacing(2)} 0;
`

export const Subtitle = styled.h3`
  ${(props) =>
    Text(
      props.theme.widget.referralStepGuide.subtitle.entry,
      props.theme.widget.referralStepGuide.subtitle.style,
    )}
  text-align: center;
  text-transform: ${(props) =>
    props.theme.widget.referralStepGuide.subtitle.transform};
  text-decoration: ${(props) =>
    props.theme.widget.referralStepGuide.subtitle.textDecoration};
  color: ${(props) => props.theme.widget.referralStepGuide.subtitle.textColor};
  padding: 0 0 ${spacing(2)} 0;
`

export const StyledGrid = styled(Grid)`
  padding: ${spacing(3.75)} ${spacing(1)};
  background-color: ${(props) =>
    props.theme.widget.referralStepGuide.backgroundColor};
`

export const StyledGridItem = styled(GridItem)`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props) => mq(props.theme.breakpointUtils.map, 'xs')} {
    margin: 0 ${spacing(2)} ${spacing(1)} ${spacing(2)};
  }
`

export const StepSubtitle = styled(SafeHtml)`
  ${(props) =>
    Text(
      props.theme.widget.referralStepGuide.stepSubtitle.entry,
      props.theme.widget.referralStepGuide.stepSubtitle.style,
    )}
  text-align: center;
  text-transform: ${(props) =>
    props.theme.widget.referralStepGuide.stepSubtitle.transform};
  text-decoration: ${(props) =>
    props.theme.widget.referralStepGuide.stepSubtitle.textDecoration};
  color: ${(props) =>
    props.theme.widget.referralStepGuide.stepSubtitle.textColor};
  margin: 0 0 ${spacing(1)} 0;

  b {
    font-weight: bold;
  }
`

export const StepText = styled(SafeHtml)`
  ${(props) =>
    Text(
      props.theme.widget.referralStepGuide.stepText.entry,
      props.theme.widget.referralStepGuide.stepText.style,
    )}
  text-align: center;
  text-transform: ${(props) =>
    props.theme.widget.referralStepGuide.stepText.transform};
  text-decoration: ${(props) =>
    props.theme.widget.referralStepGuide.stepText.textDecoration};
  color: ${(props) => props.theme.widget.referralStepGuide.stepText.textColor};
  text-align: center;
`

export const SVGContainer = styled.div`
  margin: 0 0 ${spacing(1.25)} 0;
  text-align: center;

  svg {
    height: 31px;
    width: 40px;
    fill: ${(props) => props.theme.widget.referralStepGuide.svgFill};
  }
`

export const SmallPrint = styled(SafeHtml)`
  width: 70%;
  padding: ${spacing(3.75)} 0;
  margin: auto;
  text-align: center;
`
